var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadio = function SvgRadio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "radio-coloured",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#8C95A6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "radio-inner",
    cx: 8,
    cy: 8,
    r: 7,
    fill: "white"
  })));
};
export default SvgRadio;